import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {device} from '../../styled/device';

export const PayNowStyled = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 16px;
`;

export const Status = styled.span`
  font-size: 16px;
  color: #6b6b95;
`;

export const StatusPaid = styled.div`
  display: flex;
  align-items: center;
  border-radius: 15px;
  height: 30px;
  padding: 0 15px;
  background-color: #32d7be;
  color: white;
  text-transform: capitalize;
  font-size: 16px;
  font-weight: 500;
  column-gap: 5px;
`;

export const PayNowButton = styled(Link)`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #353945;

  &:hover {
    color: #1c1c24;
  }

  svg {
    margin: 0 5px 0 10px;
  }

  @media (max-width: ${device.tablet}) {
    font-size: 20px;
    svg {
      margin: 0 2px 0 3px;
    }
  }
`;
